export const DeviceStatusEnum = {
  Offline: 0,
  Online: 1,
  Error: 2,
};

export const SensorStatusEnum = {
  Ok: 0,
  Error: 1,
};

export const GetSystemStatus = (system, fetchStatus) => {
  if (fetchStatus) {
    let sensors = undefined;
    if (system?.panels) {
      sensors = system?.panels.flatMap(panel => panel);
    }

    let deviceId = system.deviceId;

    let deviceStatus = fetchStatus.devices?.find(x => x.id === deviceId) !== undefined
      ? fetchStatus.devices?.find(x => x.id === deviceId)?.status
      : DeviceStatusEnum.Online;

    let sensorStatus = SensorStatusEnum.Ok;

    fetchStatus.sensors?.forEach(s => {
      if (sensors?.find(x => x.sensorId === s.id)) {
        sensorStatus = SensorStatusEnum.Error;
      }
    });


    return ({ deviceStatus, sensorStatus });
  }
  return ({ deviceStatus: DeviceStatusEnum.Online, sensorStatus: SensorStatusEnum.Ok });
};

export const GetLocationStatus = (location, fetchStatus) => {
  // TODO; need to add customer id at unput so it can handle admin page. 
  if (fetchStatus) {
    var statuses = [];
    location?.systems?.forEach(s => {
      statuses.push(GetSystemStatus(s, fetchStatus));
    });

    var sensorStatus = SensorStatusEnum.Ok;
    var deviceStatus = DeviceStatusEnum.Online;
    statuses.forEach(status => {

      if (status.sensorStatus === SensorStatusEnum.Error) {
        sensorStatus = SensorStatusEnum.Error;
      }

      if (status.deviceStatus === DeviceStatusEnum.Error) {
        deviceStatus = DeviceStatusEnum.Error;
      }

      if (status.deviceStatus === DeviceStatusEnum.Offline
        && status.deviceStatus !== DeviceStatusEnum.Error) {
        deviceStatus = DeviceStatusEnum.Offline;
      }
    });


    return ({ deviceStatus, sensorStatus });
  }
  return ({ deviceStatus: DeviceStatusEnum.Online, sensorStatus: SensorStatusEnum.Ok });
};

export const GetCustomerStatus = (customer, fetchStatus) => {
  if (fetchStatus) {
    var sensorStatus = SensorStatusEnum.Ok;
    var deviceStatus = DeviceStatusEnum.Online;
    if (customer) {
      var statuses = [];
      customer?.locations?.forEach(l => {
        statuses.push(GetLocationStatus(l, fetchStatus));
      });

      statuses.forEach(status => {

        if (status.sensorStatus === SensorStatusEnum.Error) {
          sensorStatus = SensorStatusEnum.Error;
        }

        if (status.deviceStatus === DeviceStatusEnum.Error) {
          deviceStatus = DeviceStatusEnum.Error;
        }

        if (status.deviceStatus === DeviceStatusEnum.Offline
          && status.deviceStatus !== DeviceStatusEnum.Error) {
          deviceStatus = DeviceStatusEnum.Offline;
        }
      });
    }
    return ({ deviceStatus, sensorStatus });
  }
  return ({ deviceStatus: DeviceStatusEnum.Online, sensorStatus: SensorStatusEnum.Ok });
};


export const GetGetDeviceStatus = (device, fetchStatus) => {
  if (fetchStatus && fetchStatus.devices) {

    var deviceStatus = fetchStatus.devices?.find(x => x.id === device.id) !== undefined
      ? fetchStatus.devices.find(x => x.id === device.id)?.status
      : DeviceStatusEnum.Online;

    var sensorStatus = SensorStatusEnum.Ok;
    return ({ deviceStatus, sensorStatus });
  }
  return ({ deviceStatus: DeviceStatusEnum.Online, sensorStatus: SensorStatusEnum.Ok });
};

